import { SVG, SVGProps } from './svg'

export function IconOhlcChartType(props: SVGProps) {
  return (
    <SVG {...props} viewBox="0 0 30 30">
      <path d="M14 3h1v6h4v1h-4v17h-1v-7h-4v-1h4V3Z" />
    </SVG>
  )
}
